<template>
  <div id="his_system" :style="`height: ${isQiankun ? 'calc(100VH - 48px)' : '100VH'}`">
    <router-view />
  </div>
</template>

<script lang="js">
export default {
  name: 'app',
  data() {
    return {
      isQiankun: window.__POWERED_BY_QIANKUN__
    }
  },
  created() {
  },
  beforeDestroy() {

  },
}
</script>

<style lang="less">
.app{
  font-size: 16px;
}
@import "./assets/css/reset.less"; // 引入重置样式
@import "./assets/css/common.less"; // 引入公用样式
@import "./assets/font/iconfont.css"; // 引入主页字体图标

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}

::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.15);
  transition: color 0.2s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

.el-message {
  top: 45px !important;
}

.el-message-box {
  width: 358px;
}
.el-tooltip__popper{
    max-width: 1000px;
}
</style>